import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { motion } from 'framer-motion';

const NavLinks = ({ isMobile }) => {
  const links = [
    { to: '/#about', label: 'About' },
    { to: '/#services', label: 'Solution & Services' },
    { to: '/', label: 'Portfolio' },
    { to: '/contact#contact', label: 'Contact Us' },
  ];

  return (
    <div className={`flex ${isMobile ? 'flex-col space-y-4' : 'items-center'}`}>
      {links.map((link, index) => (
        <HashLink
          key={index}
          smooth
          to={link.to}
          className="relative inline-flex flex-col justify-center items-center px-4 font-extrabold text-[#15467a] hover:text-[#0f395f] transition-colors duration-300
                     after:block after:h-1 after:w-0 after:bg-[#15467a] after:mt-1 after:transition-all after:duration-500 hover:after:w-full"
        >
          {link.label}
        </HashLink>
      ))}

      {/* 
      Demo button/link (currently commented out)
      <motion.div
        whileHover={{ scale: 1.05, y: -2 }}
        whileTap={{ scale: 0.95 }}
        className={`${isMobile ? '' : 'inline-block ml-4'}`}
      >
        <HashLink
          smooth
          to="/get-demo#demo"
          className="text-white bg-[#15467a] hover:bg-[#1b5a99] inline-flex items-center justify-center w-full sm:w-auto px-6 py-3 shadow-xl rounded-xl font-semibold transition-colors duration-300"
        >
          Demo our products
        </HashLink>
      </motion.div>
      */}
    </div>
  );
};

export default NavLinks;
